import { Stack, Typography } from '@mui/material';
import { InfoText } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { InfoBubble } from 'Images';

export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);
  return (
    <Stack gap='10px'>
      <Typography sx={{ fontWeight: 'bold' }}>
        {dictionary.fourthSectionCommanderDetailsTitle}
      </Typography>
      <InfoText
        text={dictionary.fourthSectionCommanderDetailsTitleInfo2}
        icon={InfoBubble}
      />
    </Stack>
  );
};
